import Vue from "vue";
import VueRouter from "vue-router";
import Page from "@/views/Page";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Search",
    component: Page,
  },
  // {
  //   path: "/opskrifter",
  //   name: "Categories",
  //   component: Page
  // },
  {
    path: "/:category",
    name: "Recipes",
    component: Page,
  },
  {
    path: "/opskrifter/:category",
    name: "Category",
    component: Page,
  },
  {
    path: "/opskrift/:url",
    name: "Recipe",
    component: Page,
  },
];

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes,
});

export default router;
